import { useCallback } from "react"

const useAttachmentsCount = ({
  sourceFiles,
  sourceTransactions,
}) => {
  const getInvestmentAttachmentsCount = useCallback((investment) => {
    const { id, isIncluded, sourceInvestmentId } = investment

    if (!isIncluded) {
      return null
    }

    if (!sourceInvestmentId) {
      const sourceAttachmentsCount = [ ...sourceFiles, ...sourceTransactions ]
        .filter(({ investmentId }) => investmentId === id)
        .length

      return sourceAttachmentsCount > 0 ? sourceAttachmentsCount : null
    }

    const migratedAttachmentsCount = [ ...sourceFiles, ...sourceTransactions ]
      .filter(({ investmentId }) => investmentId === sourceInvestmentId)
      .length

    return migratedAttachmentsCount > 0 ? `+${migratedAttachmentsCount}` : null
  }, [
    sourceFiles,
    sourceTransactions,
  ])

  return getInvestmentAttachmentsCount
}

export default useAttachmentsCount
